<template>
  <div class="wrapper" @click.stop v-if="data">
    <div class="close iconfont icon-cha" @click="bindCancel"></div>
    <img
      class="toast-top-image"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7644af8086cf39e2877b22229fb91c81.png"
      alt=""
    />
    <div class="content">
      <div class="title">是否领取该赠品？</div>
      <div class="desc">领取后无法再次领取其他赠品哦~</div>
      <div class="prize-image-bg">
        <img class="prize-image" :src="data.goods_img" alt="" />
      </div>
      <div class="prize-name">{{ data.goods_name }}</div>
      <div class="btn-list">
        <div class="btn-item btn-item-confirm" @click="bindConfirm"
          >确认领取</div
        >
        <div class="btn-item" @click="bindCancel">我再想想</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  methods: {
    bindConfirm() {
      this.$emit('confirm', this.data)
    },
    bindCancel() {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper {
  width: 247px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .close {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-sizing: border-box;
    border: 2px solid #fff;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    bottom: -40px;
    transform: translate(-50%, 0%);
  }
  .toast-top-image {
    position: absolute;
    object-fit: contain;
    z-index: -1;
    width: 151px;
    height: 151px;
    left: 50%;
    top: 0%;
    transform: translate(-50%, -50%);
  }

  .content {
    background: linear-gradient(355deg, #ffffff 0%, #fef8ed 35%, #ffebc4 100%);
    border-radius: 16px;
    padding: 17px 18px 20px;
    box-sizing: border-box;
    text-align: center;

    .title {
      font-size: 18px;
      font-family: MiSans, MiSans;
      font-weight: bold;
      color: #c47f2f;
      line-height: 24px;
      margin-bottom: 3px;
    }

    .desc {
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 12px;
    }

    .prize-image-bg {
      margin: 0 auto;
      width: 96px;
      height: 96px;
      background: #ffffff;
      border-radius: 6px;
      margin-bottom: 9px;

      .prize-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .prize-name {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      color: #c47f2f;
      line-height: 18px;
    }

    .btn-list {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .btn-item {
        width: 100px;
        height: 36px;
        line-height: 34px;
        box-sizing: border-box;
        border-radius: 20px;
        border: 1px solid rgba(196, 127, 47, 0.7);
        font-size: 13px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #c0791b;
      }
      .btn-item-confirm {
        color: #fff;
        background: #f1ae54;
        border: 1px solid #f1ae54;
      }
    }
  }
}
</style>
